import data from '../data.json'

const countryWhatIfsData = {
    "current": [
        {
            "Country": "Albania",
            "FREI": {
                "value": data.albania.future_readiness_score,
                "rank": data.albania.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.albania.physical_capital,
                "rank": data.albania.physical_capital_rank,
            },
            "Technology": {
                "value": data.albania.technology,
                "rank": data.albania.technology_rank,
            },
            "HumanCapital": {
                "value": data.albania.human_capital,
                "rank": data.albania.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.albania.competitiveness,
                "rank": data.albania.competitiveness_rank,
            }
        },
        {
            "Country": "Algeria",
            "FREI": {
                "value": data.algeria.future_readiness_score,
                "rank": data.algeria.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.algeria.physical_capital,
                "rank": data.algeria.physical_capital_rank,
            },
            "Technology": {
                "value": data.algeria.technology,
                "rank": data.algeria.technology_rank,
            },
            "HumanCapital": {
                "value": data.algeria.human_capital,
                "rank": data.algeria.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.algeria.competitiveness,
                "rank": data.algeria.competitiveness_rank,
            }
        },
        {
            "Country": "Angola",
            "FREI": {
                "value": data.angola.future_readiness_score,
                "rank": data.angola.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.angola.physical_capital,
                "rank": data.angola.physical_capital_rank,
            },
            "Technology": {
                "value": data.angola.technology,
                "rank": data.angola.technology_rank,
            },
            "HumanCapital": {
                "value": data.angola.human_capital,
                "rank": data.angola.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.angola.competitiveness,
                "rank": data.angola.competitiveness_rank,
            }
        },
        {
            "Country": "Argentina",
            "FREI": {
                "value": data.argentina.future_readiness_score,
                "rank": data.argentina.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.argentina.physical_capital,
                "rank": data.argentina.physical_capital_rank,
            },
            "Technology": {
                "value": data.argentina.technology,
                "rank": data.argentina.technology_rank,
            },
            "HumanCapital": {
                "value": data.argentina.human_capital,
                "rank": data.argentina.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.argentina.competitiveness,
                "rank": data.argentina.competitiveness_rank,
            }
        },
        {
            "Country": "Armenia",
            "FREI": {
                "value": data.armenia.future_readiness_score,
                "rank": data.armenia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.armenia.physical_capital,
                "rank": data.armenia.physical_capital_rank,
            },
            "Technology": {
                "value": data.armenia.technology,
                "rank": data.armenia.technology_rank,
            },
            "HumanCapital": {
                "value": data.armenia.human_capital,
                "rank": data.armenia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.armenia.competitiveness,
                "rank": data.armenia.competitiveness_rank,
            }
        },
        {
            "Country": "Australia",
            "FREI": {
                "value": data.australia.future_readiness_score,
                "rank": data.australia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.australia.physical_capital,
                "rank": data.australia.physical_capital_rank,
            },
            "Technology": {
                "value": data.australia.technology,
                "rank": data.australia.technology_rank,
            },
            "HumanCapital": {
                "value": data.australia.human_capital,
                "rank": data.australia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.australia.competitiveness,
                "rank": data.australia.competitiveness_rank,
            }
        },
        {
            "Country": "Austria",
            "FREI": {
                "value": data.austria.future_readiness_score,
                "rank": data.austria.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.austria.physical_capital,
                "rank": data.austria.physical_capital_rank,
            },
            "Technology": {
                "value": data.austria.technology,
                "rank": data.austria.technology_rank,
            },
            "HumanCapital": {
                "value": data.austria.human_capital,
                "rank": data.austria.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.austria.competitiveness,
                "rank": data.austria.competitiveness_rank,
            }
        },
        {
            "Country": "Azerbaijan",
            "FREI": {
                "value": data.azerbaijan.future_readiness_score,
                "rank": data.azerbaijan.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.azerbaijan.physical_capital,
                "rank": data.azerbaijan.physical_capital_rank,
            },
            "Technology": {
                "value": data.azerbaijan.technology,
                "rank": data.azerbaijan.technology_rank,
            },
            "HumanCapital": {
                "value": data.azerbaijan.human_capital,
                "rank": data.azerbaijan.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.azerbaijan.competitiveness,
                "rank": data.azerbaijan.competitiveness_rank,
            }
        },
        {
            "Country": "Bahrain",
            "FREI": {
                "value": data.bahrain.future_readiness_score,
                "rank": data.bahrain.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.bahrain.physical_capital,
                "rank": data.bahrain.physical_capital_rank,
            },
            "Technology": {
                "value": data.bahrain.technology,
                "rank": data.bahrain.technology_rank,
            },
            "HumanCapital": {
                "value": data.bahrain.human_capital,
                "rank": data.bahrain.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.bahrain.competitiveness,
                "rank": data.bahrain.competitiveness_rank,
            }
        },
        {
            "Country": "Bangladesh",
            "FREI": {
                "value": data.bangladesh.future_readiness_score,
                "rank": data.bangladesh.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.bangladesh.physical_capital,
                "rank": data.bangladesh.physical_capital_rank,
            },
            "Technology": {
                "value": data.bangladesh.technology,
                "rank": data.bangladesh.technology_rank,
            },
            "HumanCapital": {
                "value": data.bangladesh.human_capital,
                "rank": data.bangladesh.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.bangladesh.competitiveness,
                "rank": data.bangladesh.competitiveness_rank,
            }
        },
        {
            "Country": "Belarus",
            "FREI": {
                "value": data.belarus.future_readiness_score,
                "rank": data.belarus.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.belarus.physical_capital,
                "rank": data.belarus.physical_capital_rank,
            },
            "Technology": {
                "value": data.belarus.technology,
                "rank": data.belarus.technology_rank,
            },
            "HumanCapital": {
                "value": data.belarus.human_capital,
                "rank": data.belarus.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.belarus.competitiveness,
                "rank": data.belarus.competitiveness_rank,
            }
        },
        {
            "Country": "Belgium",
            "FREI": {
                "value": data.belgium.future_readiness_score,
                "rank": data.belgium.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.belgium.physical_capital,
                "rank": data.belgium.physical_capital_rank,
            },
            "Technology": {
                "value": data.belgium.technology,
                "rank": data.belgium.technology_rank,
            },
            "HumanCapital": {
                "value": data.belgium.human_capital,
                "rank": data.belgium.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.belgium.competitiveness,
                "rank": data.belgium.competitiveness_rank,
            }
        },
        {
            "Country": "Benin",
            "FREI": {
                "value": data.benin.future_readiness_score,
                "rank": data.benin.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.benin.physical_capital,
                "rank": data.benin.physical_capital_rank,
            },
            "Technology": {
                "value": data.benin.technology,
                "rank": data.benin.technology_rank,
            },
            "HumanCapital": {
                "value": data.benin.human_capital,
                "rank": data.benin.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.benin.competitiveness,
                "rank": data.benin.competitiveness_rank,
            }
        },
        {
            "Country": "Bolivia",
            "FREI": {
                "value": data.bolivia.future_readiness_score,
                "rank": data.bolivia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.bolivia.physical_capital,
                "rank": data.bolivia.physical_capital_rank,
            },
            "Technology": {
                "value": data.bolivia.technology,
                "rank": data.bolivia.technology_rank,
            },
            "HumanCapital": {
                "value": data.bolivia.human_capital,
                "rank": data.bolivia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.bolivia.competitiveness,
                "rank": data.bolivia.competitiveness_rank,
            }
        },
        {
            "Country": "Bosnia and Herzegovina",
            "FREI": {
                "value": data.bosnia_and_herzegovina.future_readiness_score,
                "rank": data.bosnia_and_herzegovina.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.bosnia_and_herzegovina.physical_capital,
                "rank": data.bosnia_and_herzegovina.physical_capital_rank,
            },
            "Technology": {
                "value": data.bosnia_and_herzegovina.technology,
                "rank": data.bosnia_and_herzegovina.technology_rank,
            },
            "HumanCapital": {
                "value": data.bosnia_and_herzegovina.human_capital,
                "rank": data.bosnia_and_herzegovina.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.bosnia_and_herzegovina.competitiveness,
                "rank": data.bosnia_and_herzegovina.competitiveness_rank,
            }
        },
        {
            "Country": "Botswana",
            "FREI": {
                "value": data.botswana.future_readiness_score,
                "rank": data.botswana.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.botswana.physical_capital,
                "rank": data.botswana.physical_capital_rank,
            },
            "Technology": {
                "value": data.botswana.technology,
                "rank": data.botswana.technology_rank,
            },
            "HumanCapital": {
                "value": data.botswana.human_capital,
                "rank": data.botswana.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.botswana.competitiveness,
                "rank": data.botswana.competitiveness_rank,
            }
        },
        {
            "Country": "Brazil",
            "FREI": {
                "value": data.brazil.future_readiness_score,
                "rank": data.brazil.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.brazil.physical_capital,
                "rank": data.brazil.physical_capital_rank,
            },
            "Technology": {
                "value": data.brazil.technology,
                "rank": data.brazil.technology_rank,
            },
            "HumanCapital": {
                "value": data.brazil.human_capital,
                "rank": data.brazil.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.brazil.competitiveness,
                "rank": data.brazil.competitiveness_rank,
            }
        },
        {
            "Country": "Bulgaria",
            "FREI": {
                "value": data.bulgaria.future_readiness_score,
                "rank": data.bulgaria.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.bulgaria.physical_capital,
                "rank": data.bulgaria.physical_capital_rank,
            },
            "Technology": {
                "value": data.bulgaria.technology,
                "rank": data.bulgaria.technology_rank,
            },
            "HumanCapital": {
                "value": data.bulgaria.human_capital,
                "rank": data.bulgaria.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.bulgaria.competitiveness,
                "rank": data.bulgaria.competitiveness_rank,
            }
        },
        {
            "Country": "Burkina Faso",
            "FREI": {
                "value": data.burkina_faso.future_readiness_score,
                "rank": data.burkina_faso.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.burkina_faso.physical_capital,
                "rank": data.burkina_faso.physical_capital_rank,
            },
            "Technology": {
                "value": data.burkina_faso.technology,
                "rank": data.burkina_faso.technology_rank,
            },
            "HumanCapital": {
                "value": data.burkina_faso.human_capital,
                "rank": data.burkina_faso.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.burkina_faso.competitiveness,
                "rank": data.burkina_faso.competitiveness_rank,
            }
        },
        {
            "Country": "Cambodia",
            "FREI": {
                "value": data.cambodia.future_readiness_score,
                "rank": data.cambodia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.cambodia.physical_capital,
                "rank": data.cambodia.physical_capital_rank,
            },
            "Technology": {
                "value": data.cambodia.technology,
                "rank": data.cambodia.technology_rank,
            },
            "HumanCapital": {
                "value": data.cambodia.human_capital,
                "rank": data.cambodia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.cambodia.competitiveness,
                "rank": data.cambodia.competitiveness_rank,
            }
        },
        {
            "Country": "Cameroon",
            "FREI": {
                "value": data.cameroon.future_readiness_score,
                "rank": data.cameroon.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.cameroon.physical_capital,
                "rank": data.cameroon.physical_capital_rank,
            },
            "Technology": {
                "value": data.cameroon.technology,
                "rank": data.cameroon.technology_rank,
            },
            "HumanCapital": {
                "value": data.cameroon.human_capital,
                "rank": data.cameroon.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.cameroon.competitiveness,
                "rank": data.cameroon.competitiveness_rank,
            }
        },
        {
            "Country": "Canada",
            "FREI": {
                "value": data.canada.future_readiness_score,
                "rank": data.canada.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.canada.physical_capital,
                "rank": data.canada.physical_capital_rank,
            },
            "Technology": {
                "value": data.canada.technology,
                "rank": data.canada.technology_rank,
            },
            "HumanCapital": {
                "value": data.canada.human_capital,
                "rank": data.canada.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.canada.competitiveness,
                "rank": data.canada.competitiveness_rank,
            }
        },
        {
            "Country": "Chile",
            "FREI": {
                "value": data.chile.future_readiness_score,
                "rank": data.chile.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.chile.physical_capital,
                "rank": data.chile.physical_capital_rank,
            },
            "Technology": {
                "value": data.chile.technology,
                "rank": data.chile.technology_rank,
            },
            "HumanCapital": {
                "value": data.chile.human_capital,
                "rank": data.chile.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.chile.competitiveness,
                "rank": data.chile.competitiveness_rank,
            }
        },
        {
            "Country": "China",
            "FREI": {
                "value": data.china.future_readiness_score,
                "rank": data.china.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.china.physical_capital,
                "rank": data.china.physical_capital_rank,
            },
            "Technology": {
                "value": data.china.technology,
                "rank": data.china.technology_rank,
            },
            "HumanCapital": {
                "value": data.china.human_capital,
                "rank": data.china.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.china.competitiveness,
                "rank": data.china.competitiveness_rank,
            }
        },
        {
            "Country": "Colombia",
            "FREI": {
                "value": data.colombia.future_readiness_score,
                "rank": data.colombia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.colombia.physical_capital,
                "rank": data.colombia.physical_capital_rank,
            },
            "Technology": {
                "value": data.colombia.technology,
                "rank": data.colombia.technology_rank,
            },
            "HumanCapital": {
                "value": data.colombia.human_capital,
                "rank": data.colombia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.colombia.competitiveness,
                "rank": data.colombia.competitiveness_rank,
            }
        },
        {
            "Country": "Costa Rica",
            "FREI": {
                "value": data.costa_rica.future_readiness_score,
                "rank": data.costa_rica.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.costa_rica.physical_capital,
                "rank": data.costa_rica.physical_capital_rank,
            },
            "Technology": {
                "value": data.costa_rica.technology,
                "rank": data.costa_rica.technology_rank,
            },
            "HumanCapital": {
                "value": data.costa_rica.human_capital,
                "rank": data.costa_rica.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.costa_rica.competitiveness,
                "rank": data.costa_rica.competitiveness_rank,
            }
        },
        {
            "Country": "Côte d'Ivoire",
            "FREI": {
                "value": data.cote_divoire.future_readiness_score,
                "rank": data.cote_divoire.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.cote_divoire.physical_capital,
                "rank": data.cote_divoire.physical_capital_rank,
            },
            "Technology": {
                "value": data.cote_divoire.technology,
                "rank": data.cote_divoire.technology_rank,
            },
            "HumanCapital": {
                "value": data.cote_divoire.human_capital,
                "rank": data.cote_divoire.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.cote_divoire.competitiveness,
                "rank": data.cote_divoire.competitiveness_rank,
            }
        },
        {
            "Country": "Croatia",
            "FREI": {
                "value": data.croatia.future_readiness_score,
                "rank": data.croatia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.croatia.physical_capital,
                "rank": data.croatia.physical_capital_rank,
            },
            "Technology": {
                "value": data.croatia.technology,
                "rank": data.croatia.technology_rank,
            },
            "HumanCapital": {
                "value": data.croatia.human_capital,
                "rank": data.croatia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.croatia.competitiveness,
                "rank": data.croatia.competitiveness_rank,
            }
        },
        {
            "Country": "Cyprus",
            "FREI": {
                "value": data.cyprus.future_readiness_score,
                "rank": data.cyprus.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.cyprus.physical_capital,
                "rank": data.cyprus.physical_capital_rank,
            },
            "Technology": {
                "value": data.cyprus.technology,
                "rank": data.cyprus.technology_rank,
            },
            "HumanCapital": {
                "value": data.cyprus.human_capital,
                "rank": data.cyprus.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.cyprus.competitiveness,
                "rank": data.cyprus.competitiveness_rank,
            }
        },
        {
            "Country": "Czech Republic",
            "FREI": {
                "value": data.czech_republic.future_readiness_score,
                "rank": data.czech_republic.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.czech_republic.physical_capital,
                "rank": data.czech_republic.physical_capital_rank,
            },
            "Technology": {
                "value": data.czech_republic.technology,
                "rank": data.czech_republic.technology_rank,
            },
            "HumanCapital": {
                "value": data.czech_republic.human_capital,
                "rank": data.czech_republic.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.czech_republic.competitiveness,
                "rank": data.czech_republic.competitiveness_rank,
            }
        },
        {
            "Country": "Denmark",
            "FREI": {
                "value": data.denmark.future_readiness_score,
                "rank": data.denmark.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.denmark.physical_capital,
                "rank": data.denmark.physical_capital_rank,
            },
            "Technology": {
                "value": data.denmark.technology,
                "rank": data.denmark.technology_rank,
            },
            "HumanCapital": {
                "value": data.denmark.human_capital,
                "rank": data.denmark.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.denmark.competitiveness,
                "rank": data.denmark.competitiveness_rank,
            }
        },
        {
            "Country": "Dominican Republic",
            "FREI": {
                "value": data.dominican_republic.future_readiness_score,
                "rank": data.dominican_republic.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.dominican_republic.physical_capital,
                "rank": data.dominican_republic.physical_capital_rank,
            },
            "Technology": {
                "value": data.dominican_republic.technology,
                "rank": data.dominican_republic.technology_rank,
            },
            "HumanCapital": {
                "value": data.dominican_republic.human_capital,
                "rank": data.dominican_republic.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.dominican_republic.competitiveness,
                "rank": data.dominican_republic.competitiveness_rank,
            }
        },
        {
            "Country": "Ecuador",
            "FREI": {
                "value": data.ecuador.future_readiness_score,
                "rank": data.ecuador.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.ecuador.physical_capital,
                "rank": data.ecuador.physical_capital_rank,
            },
            "Technology": {
                "value": data.ecuador.technology,
                "rank": data.ecuador.technology_rank,
            },
            "HumanCapital": {
                "value": data.ecuador.human_capital,
                "rank": data.ecuador.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.ecuador.competitiveness,
                "rank": data.ecuador.competitiveness_rank,
            }
        },
        {
            "Country": "Egypt",
            "FREI": {
                "value": data.egypt.future_readiness_score,
                "rank": data.egypt.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.egypt.physical_capital,
                "rank": data.egypt.physical_capital_rank,
            },
            "Technology": {
                "value": data.egypt.technology,
                "rank": data.egypt.technology_rank,
            },
            "HumanCapital": {
                "value": data.egypt.human_capital,
                "rank": data.egypt.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.egypt.competitiveness,
                "rank": data.egypt.competitiveness_rank,
            }
        },
        {
            "Country": "El Salvador",
            "FREI": {
                "value": data.el_salvador.future_readiness_score,
                "rank": data.el_salvador.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.el_salvador.physical_capital,
                "rank": data.el_salvador.physical_capital_rank,
            },
            "Technology": {
                "value": data.el_salvador.technology,
                "rank": data.el_salvador.technology_rank,
            },
            "HumanCapital": {
                "value": data.el_salvador.human_capital,
                "rank": data.el_salvador.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.el_salvador.competitiveness,
                "rank": data.el_salvador.competitiveness_rank,
            }
        },
        {
            "Country": "Estonia",
            "FREI": {
                "value": data.estonia.future_readiness_score,
                "rank": data.estonia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.estonia.physical_capital,
                "rank": data.estonia.physical_capital_rank,
            },
            "Technology": {
                "value": data.estonia.technology,
                "rank": data.estonia.technology_rank,
            },
            "HumanCapital": {
                "value": data.estonia.human_capital,
                "rank": data.estonia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.estonia.competitiveness,
                "rank": data.estonia.competitiveness_rank,
            }
        },
        {
            "Country": "Ethiopia",
            "FREI": {
                "value": data.ethiopia.future_readiness_score,
                "rank": data.ethiopia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.ethiopia.physical_capital,
                "rank": data.ethiopia.physical_capital_rank,
            },
            "Technology": {
                "value": data.ethiopia.technology,
                "rank": data.ethiopia.technology_rank,
            },
            "HumanCapital": {
                "value": data.ethiopia.human_capital,
                "rank": data.ethiopia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.ethiopia.competitiveness,
                "rank": data.ethiopia.competitiveness_rank,
            }
        },
        {
            "Country": "Finland",
            "FREI": {
                "value": data.finland.future_readiness_score,
                "rank": data.finland.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.finland.physical_capital,
                "rank": data.finland.physical_capital_rank,
            },
            "Technology": {
                "value": data.finland.technology,
                "rank": data.finland.technology_rank,
            },
            "HumanCapital": {
                "value": data.finland.human_capital,
                "rank": data.finland.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.finland.competitiveness,
                "rank": data.finland.competitiveness_rank,
            }
        },
        {
            "Country": "France",
            "FREI": {
                "value": data.france.future_readiness_score,
                "rank": data.france.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.france.physical_capital,
                "rank": data.france.physical_capital_rank,
            },
            "Technology": {
                "value": data.france.technology,
                "rank": data.france.technology_rank,
            },
            "HumanCapital": {
                "value": data.france.human_capital,
                "rank": data.france.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.france.competitiveness,
                "rank": data.france.competitiveness_rank,
            }
        },
        {
            "Country": "Georgia",
            "FREI": {
                "value": data.georgia.future_readiness_score,
                "rank": data.georgia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.georgia.physical_capital,
                "rank": data.georgia.physical_capital_rank,
            },
            "Technology": {
                "value": data.georgia.technology,
                "rank": data.georgia.technology_rank,
            },
            "HumanCapital": {
                "value": data.georgia.human_capital,
                "rank": data.georgia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.georgia.competitiveness,
                "rank": data.georgia.competitiveness_rank,
            }
        },
        {
            "Country": "Germany",
            "FREI": {
                "value": data.germany.future_readiness_score,
                "rank": data.germany.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.germany.physical_capital,
                "rank": data.germany.physical_capital_rank,
            },
            "Technology": {
                "value": data.germany.technology,
                "rank": data.germany.technology_rank,
            },
            "HumanCapital": {
                "value": data.germany.human_capital,
                "rank": data.germany.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.germany.competitiveness,
                "rank": data.germany.competitiveness_rank,
            }
        },
        {
            "Country": "Ghana",
            "FREI": {
                "value": data.ghana.future_readiness_score,
                "rank": data.ghana.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.ghana.physical_capital,
                "rank": data.ghana.physical_capital_rank,
            },
            "Technology": {
                "value": data.ghana.technology,
                "rank": data.ghana.technology_rank,
            },
            "HumanCapital": {
                "value": data.ghana.human_capital,
                "rank": data.ghana.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.ghana.competitiveness,
                "rank": data.ghana.competitiveness_rank,
            }
        },
        {
            "Country": "Greece",
            "FREI": {
                "value": data.greece.future_readiness_score,
                "rank": data.greece.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.greece.physical_capital,
                "rank": data.greece.physical_capital_rank,
            },
            "Technology": {
                "value": data.greece.technology,
                "rank": data.greece.technology_rank,
            },
            "HumanCapital": {
                "value": data.greece.human_capital,
                "rank": data.greece.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.greece.competitiveness,
                "rank": data.greece.competitiveness_rank,
            }
        },
        {
            "Country": "Guatemala",
            "FREI": {
                "value": data.guatemala.future_readiness_score,
                "rank": data.guatemala.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.guatemala.physical_capital,
                "rank": data.guatemala.physical_capital_rank,
            },
            "Technology": {
                "value": data.guatemala.technology,
                "rank": data.guatemala.technology_rank,
            },
            "HumanCapital": {
                "value": data.guatemala.human_capital,
                "rank": data.guatemala.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.guatemala.competitiveness,
                "rank": data.guatemala.competitiveness_rank,
            }
        },
        {
            "Country": "Guinea",
            "FREI": {
                "value": data.guinea.future_readiness_score,
                "rank": data.guinea.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.guinea.physical_capital,
                "rank": data.guinea.physical_capital_rank,
            },
            "Technology": {
                "value": data.guinea.technology,
                "rank": data.guinea.technology_rank,
            },
            "HumanCapital": {
                "value": data.guinea.human_capital,
                "rank": data.guinea.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.guinea.competitiveness,
                "rank": data.guinea.competitiveness_rank,
            }
        },
        {
            "Country": "Honduras",
            "FREI": {
                "value": data.honduras.future_readiness_score,
                "rank": data.honduras.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.honduras.physical_capital,
                "rank": data.honduras.physical_capital_rank,
            },
            "Technology": {
                "value": data.honduras.technology,
                "rank": data.honduras.technology_rank,
            },
            "HumanCapital": {
                "value": data.honduras.human_capital,
                "rank": data.honduras.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.honduras.competitiveness,
                "rank": data.honduras.competitiveness_rank,
            }
        },
        {
            "Country": "Hungary",
            "FREI": {
                "value": data.hungary.future_readiness_score,
                "rank": data.hungary.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.hungary.physical_capital,
                "rank": data.hungary.physical_capital_rank,
            },
            "Technology": {
                "value": data.hungary.technology,
                "rank": data.hungary.technology_rank,
            },
            "HumanCapital": {
                "value": data.hungary.human_capital,
                "rank": data.hungary.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.hungary.competitiveness,
                "rank": data.hungary.competitiveness_rank,
            }
        },
        {
            "Country": "Iceland",
            "FREI": {
                "value": data.iceland.future_readiness_score,
                "rank": data.iceland.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.iceland.physical_capital,
                "rank": data.iceland.physical_capital_rank,
            },
            "Technology": {
                "value": data.iceland.technology,
                "rank": data.iceland.technology_rank,
            },
            "HumanCapital": {
                "value": data.iceland.human_capital,
                "rank": data.iceland.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.iceland.competitiveness,
                "rank": data.iceland.competitiveness_rank,
            }
        },
        {
            "Country": "India",
            "FREI": {
                "value": data.india.future_readiness_score,
                "rank": data.india.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.india.physical_capital,
                "rank": data.india.physical_capital_rank,
            },
            "Technology": {
                "value": data.india.technology,
                "rank": data.india.technology_rank,
            },
            "HumanCapital": {
                "value": data.india.human_capital,
                "rank": data.india.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.india.competitiveness,
                "rank": data.india.competitiveness_rank,
            }
        },
        {
            "Country": "Indonesia",
            "FREI": {
                "value": data.indonesia.future_readiness_score,
                "rank": data.indonesia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.indonesia.physical_capital,
                "rank": data.indonesia.physical_capital_rank,
            },
            "Technology": {
                "value": data.indonesia.technology,
                "rank": data.indonesia.technology_rank,
            },
            "HumanCapital": {
                "value": data.indonesia.human_capital,
                "rank": data.indonesia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.indonesia.competitiveness,
                "rank": data.indonesia.competitiveness_rank,
            }
        },
        {
            "Country": "Iran",
            "FREI": {
                "value": data.iran.future_readiness_score,
                "rank": data.iran.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.iran.physical_capital,
                "rank": data.iran.physical_capital_rank,
            },
            "Technology": {
                "value": data.iran.technology,
                "rank": data.iran.technology_rank,
            },
            "HumanCapital": {
                "value": data.iran.human_capital,
                "rank": data.iran.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.iran.competitiveness,
                "rank": data.iran.competitiveness_rank,
            }
        },
        {
            "Country": "Ireland",
            "FREI": {
                "value": data.ireland.future_readiness_score,
                "rank": data.ireland.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.ireland.physical_capital,
                "rank": data.ireland.physical_capital_rank,
            },
            "Technology": {
                "value": data.ireland.technology,
                "rank": data.ireland.technology_rank,
            },
            "HumanCapital": {
                "value": data.ireland.human_capital,
                "rank": data.ireland.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.ireland.competitiveness,
                "rank": data.ireland.competitiveness_rank,
            }
        },
        {
            "Country": "Israel",
            "FREI": {
                "value": data.israel.future_readiness_score,
                "rank": data.israel.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.israel.physical_capital,
                "rank": data.israel.physical_capital_rank,
            },
            "Technology": {
                "value": data.israel.technology,
                "rank": data.israel.technology_rank,
            },
            "HumanCapital": {
                "value": data.israel.human_capital,
                "rank": data.israel.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.israel.competitiveness,
                "rank": data.israel.competitiveness_rank,
            }
        },
        {
            "Country": "Italy",
            "FREI": {
                "value": data.italy.future_readiness_score,
                "rank": data.italy.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.italy.physical_capital,
                "rank": data.italy.physical_capital_rank,
            },
            "Technology": {
                "value": data.italy.technology,
                "rank": data.italy.technology_rank,
            },
            "HumanCapital": {
                "value": data.italy.human_capital,
                "rank": data.italy.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.italy.competitiveness,
                "rank": data.italy.competitiveness_rank,
            }
        },
        {
            "Country": "Jamaica",
            "FREI": {
                "value": data.jamaica.future_readiness_score,
                "rank": data.jamaica.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.jamaica.physical_capital,
                "rank": data.jamaica.physical_capital_rank,
            },
            "Technology": {
                "value": data.jamaica.technology,
                "rank": data.jamaica.technology_rank,
            },
            "HumanCapital": {
                "value": data.jamaica.human_capital,
                "rank": data.jamaica.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.jamaica.competitiveness,
                "rank": data.jamaica.competitiveness_rank,
            }
        },
        {
            "Country": "Japan",
            "FREI": {
                "value": data.japan.future_readiness_score,
                "rank": data.japan.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.japan.physical_capital,
                "rank": data.japan.physical_capital_rank,
            },
            "Technology": {
                "value": data.japan.technology,
                "rank": data.japan.technology_rank,
            },
            "HumanCapital": {
                "value": data.japan.human_capital,
                "rank": data.japan.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.japan.competitiveness,
                "rank": data.japan.competitiveness_rank,
            }
        },
        {
            "Country": "Jordan",
            "FREI": {
                "value": data.jordan.future_readiness_score,
                "rank": data.jordan.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.jordan.physical_capital,
                "rank": data.jordan.physical_capital_rank,
            },
            "Technology": {
                "value": data.jordan.technology,
                "rank": data.jordan.technology_rank,
            },
            "HumanCapital": {
                "value": data.jordan.human_capital,
                "rank": data.jordan.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.jordan.competitiveness,
                "rank": data.jordan.competitiveness_rank,
            }
        },
        {
            "Country": "Kazakhstan",
            "FREI": {
                "value": data.kazakhstan.future_readiness_score,
                "rank": data.kazakhstan.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.kazakhstan.physical_capital,
                "rank": data.kazakhstan.physical_capital_rank,
            },
            "Technology": {
                "value": data.kazakhstan.technology,
                "rank": data.kazakhstan.technology_rank,
            },
            "HumanCapital": {
                "value": data.kazakhstan.human_capital,
                "rank": data.kazakhstan.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.kazakhstan.competitiveness,
                "rank": data.kazakhstan.competitiveness_rank,
            }
        },
        {
            "Country": "Kenya",
            "FREI": {
                "value": data.kenya.future_readiness_score,
                "rank": data.kenya.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.kenya.physical_capital,
                "rank": data.kenya.physical_capital_rank,
            },
            "Technology": {
                "value": data.kenya.technology,
                "rank": data.kenya.technology_rank,
            },
            "HumanCapital": {
                "value": data.kenya.human_capital,
                "rank": data.kenya.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.kenya.competitiveness,
                "rank": data.kenya.competitiveness_rank,
            }
        },
        {
            "Country": "Kuwait",
            "FREI": {
                "value": data.kuwait.future_readiness_score,
                "rank": data.kuwait.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.kuwait.physical_capital,
                "rank": data.kuwait.physical_capital_rank,
            },
            "Technology": {
                "value": data.kuwait.technology,
                "rank": data.kuwait.technology_rank,
            },
            "HumanCapital": {
                "value": data.kuwait.human_capital,
                "rank": data.kuwait.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.kuwait.competitiveness,
                "rank": data.kuwait.competitiveness_rank,
            }
        },
        {
            "Country": "Kyrgyzstan",
            "FREI": {
                "value": data.kyrgyzstan.future_readiness_score,
                "rank": data.kyrgyzstan.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.kyrgyzstan.physical_capital,
                "rank": data.kyrgyzstan.physical_capital_rank,
            },
            "Technology": {
                "value": data.kyrgyzstan.technology,
                "rank": data.kyrgyzstan.technology_rank,
            },
            "HumanCapital": {
                "value": data.kyrgyzstan.human_capital,
                "rank": data.kyrgyzstan.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.kyrgyzstan.competitiveness,
                "rank": data.kyrgyzstan.competitiveness_rank,
            }
        },
        {
            "Country": "Laos",
            "FREI": {
                "value": data.laos.future_readiness_score,
                "rank": data.laos.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.laos.physical_capital,
                "rank": data.laos.physical_capital_rank,
            },
            "Technology": {
                "value": data.laos.technology,
                "rank": data.laos.technology_rank,
            },
            "HumanCapital": {
                "value": data.laos.human_capital,
                "rank": data.laos.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.laos.competitiveness,
                "rank": data.laos.competitiveness_rank,
            }
        },
        {
            "Country": "Latvia",
            "FREI": {
                "value": data.latvia.future_readiness_score,
                "rank": data.latvia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.latvia.physical_capital,
                "rank": data.latvia.physical_capital_rank,
            },
            "Technology": {
                "value": data.latvia.technology,
                "rank": data.latvia.technology_rank,
            },
            "HumanCapital": {
                "value": data.latvia.human_capital,
                "rank": data.latvia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.latvia.competitiveness,
                "rank": data.latvia.competitiveness_rank,
            }
        },
        {
            "Country": "Lebanon",
            "FREI": {
                "value": data.lebanon.future_readiness_score,
                "rank": data.lebanon.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.lebanon.physical_capital,
                "rank": data.lebanon.physical_capital_rank,
            },
            "Technology": {
                "value": data.lebanon.technology,
                "rank": data.lebanon.technology_rank,
            },
            "HumanCapital": {
                "value": data.lebanon.human_capital,
                "rank": data.lebanon.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.lebanon.competitiveness,
                "rank": data.lebanon.competitiveness_rank,
            }
        },
        {
            "Country": "Lithuania",
            "FREI": {
                "value": data.lithuania.future_readiness_score,
                "rank": data.lithuania.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.lithuania.physical_capital,
                "rank": data.lithuania.physical_capital_rank,
            },
            "Technology": {
                "value": data.lithuania.technology,
                "rank": data.lithuania.technology_rank,
            },
            "HumanCapital": {
                "value": data.lithuania.human_capital,
                "rank": data.lithuania.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.lithuania.competitiveness,
                "rank": data.lithuania.competitiveness_rank,
            }
        },
        {
            "Country": "Luxembourg",
            "FREI": {
                "value": data.luxembourg.future_readiness_score,
                "rank": data.luxembourg.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.luxembourg.physical_capital,
                "rank": data.luxembourg.physical_capital_rank,
            },
            "Technology": {
                "value": data.luxembourg.technology,
                "rank": data.luxembourg.technology_rank,
            },
            "HumanCapital": {
                "value": data.luxembourg.human_capital,
                "rank": data.luxembourg.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.luxembourg.competitiveness,
                "rank": data.luxembourg.competitiveness_rank,
            }
        },
        {
            "Country": "Madagascar",
            "FREI": {
                "value": data.madagascar.future_readiness_score,
                "rank": data.madagascar.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.madagascar.physical_capital,
                "rank": data.madagascar.physical_capital_rank,
            },
            "Technology": {
                "value": data.madagascar.technology,
                "rank": data.madagascar.technology_rank,
            },
            "HumanCapital": {
                "value": data.madagascar.human_capital,
                "rank": data.madagascar.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.madagascar.competitiveness,
                "rank": data.madagascar.competitiveness_rank,
            }
        },
        {
            "Country": "Malawi",
            "FREI": {
                "value": data.malawi.future_readiness_score,
                "rank": data.malawi.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.malawi.physical_capital,
                "rank": data.malawi.physical_capital_rank,
            },
            "Technology": {
                "value": data.malawi.technology,
                "rank": data.malawi.technology_rank,
            },
            "HumanCapital": {
                "value": data.malawi.human_capital,
                "rank": data.malawi.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.malawi.competitiveness,
                "rank": data.malawi.competitiveness_rank,
            }
        },
        {
            "Country": "Malaysia",
            "FREI": {
                "value": data.malaysia.future_readiness_score,
                "rank": data.malaysia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.malaysia.physical_capital,
                "rank": data.malaysia.physical_capital_rank,
            },
            "Technology": {
                "value": data.malaysia.technology,
                "rank": data.malaysia.technology_rank,
            },
            "HumanCapital": {
                "value": data.malaysia.human_capital,
                "rank": data.malaysia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.malaysia.competitiveness,
                "rank": data.malaysia.competitiveness_rank,
            }
        },
        {
            "Country": "Mali",
            "FREI": {
                "value": data.mali.future_readiness_score,
                "rank": data.mali.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.mali.physical_capital,
                "rank": data.mali.physical_capital_rank,
            },
            "Technology": {
                "value": data.mali.technology,
                "rank": data.mali.technology_rank,
            },
            "HumanCapital": {
                "value": data.mali.human_capital,
                "rank": data.mali.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.mali.competitiveness,
                "rank": data.mali.competitiveness_rank,
            }
        },
        {
            "Country": "Malta",
            "FREI": {
                "value": data.malta.future_readiness_score,
                "rank": data.malta.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.malta.physical_capital,
                "rank": data.malta.physical_capital_rank,
            },
            "Technology": {
                "value": data.malta.technology,
                "rank": data.malta.technology_rank,
            },
            "HumanCapital": {
                "value": data.malta.human_capital,
                "rank": data.malta.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.malta.competitiveness,
                "rank": data.malta.competitiveness_rank,
            }
        },
        {
            "Country": "Mauritius",
            "FREI": {
                "value": data.mauritius.future_readiness_score,
                "rank": data.mauritius.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.mauritius.physical_capital,
                "rank": data.mauritius.physical_capital_rank,
            },
            "Technology": {
                "value": data.mauritius.technology,
                "rank": data.mauritius.technology_rank,
            },
            "HumanCapital": {
                "value": data.mauritius.human_capital,
                "rank": data.mauritius.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.mauritius.competitiveness,
                "rank": data.mauritius.competitiveness_rank,
            }
        },
        {
            "Country": "Mexico",
            "FREI": {
                "value": data.mexico.future_readiness_score,
                "rank": data.mexico.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.mexico.physical_capital,
                "rank": data.mexico.physical_capital_rank,
            },
            "Technology": {
                "value": data.mexico.technology,
                "rank": data.mexico.technology_rank,
            },
            "HumanCapital": {
                "value": data.mexico.human_capital,
                "rank": data.mexico.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.mexico.competitiveness,
                "rank": data.mexico.competitiveness_rank,
            }
        },
        {
            "Country": "Moldova",
            "FREI": {
                "value": data.moldova.future_readiness_score,
                "rank": data.moldova.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.moldova.physical_capital,
                "rank": data.moldova.physical_capital_rank,
            },
            "Technology": {
                "value": data.moldova.technology,
                "rank": data.moldova.technology_rank,
            },
            "HumanCapital": {
                "value": data.moldova.human_capital,
                "rank": data.moldova.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.moldova.competitiveness,
                "rank": data.moldova.competitiveness_rank,
            }
        },
        {
            "Country": "Mongolia",
            "FREI": {
                "value": data.mongolia.future_readiness_score,
                "rank": data.mongolia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.mongolia.physical_capital,
                "rank": data.mongolia.physical_capital_rank,
            },
            "Technology": {
                "value": data.mongolia.technology,
                "rank": data.mongolia.technology_rank,
            },
            "HumanCapital": {
                "value": data.mongolia.human_capital,
                "rank": data.mongolia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.mongolia.competitiveness,
                "rank": data.mongolia.competitiveness_rank,
            }
        },
        {
            "Country": "Morocco",
            "FREI": {
                "value": data.morocco.future_readiness_score,
                "rank": data.morocco.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.morocco.physical_capital,
                "rank": data.morocco.physical_capital_rank,
            },
            "Technology": {
                "value": data.morocco.technology,
                "rank": data.morocco.technology_rank,
            },
            "HumanCapital": {
                "value": data.morocco.human_capital,
                "rank": data.morocco.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.morocco.competitiveness,
                "rank": data.morocco.competitiveness_rank,
            }
        },
        {
            "Country": "Mozambique",
            "FREI": {
                "value": data.mozambique.future_readiness_score,
                "rank": data.mozambique.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.mozambique.physical_capital,
                "rank": data.mozambique.physical_capital_rank,
            },
            "Technology": {
                "value": data.mozambique.technology,
                "rank": data.mozambique.technology_rank,
            },
            "HumanCapital": {
                "value": data.mozambique.human_capital,
                "rank": data.mozambique.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.mozambique.competitiveness,
                "rank": data.mozambique.competitiveness_rank,
            }
        },
        {
            "Country": "Myanmar",
            "FREI": {
                "value": data.myanmar.future_readiness_score,
                "rank": data.myanmar.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.myanmar.physical_capital,
                "rank": data.myanmar.physical_capital_rank,
            },
            "Technology": {
                "value": data.myanmar.technology,
                "rank": data.myanmar.technology_rank,
            },
            "HumanCapital": {
                "value": data.myanmar.human_capital,
                "rank": data.myanmar.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.myanmar.competitiveness,
                "rank": data.myanmar.competitiveness_rank,
            }
        },
        {
            "Country": "Nepal",
            "FREI": {
                "value": data.nepal.future_readiness_score,
                "rank": data.nepal.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.nepal.physical_capital,
                "rank": data.nepal.physical_capital_rank,
            },
            "Technology": {
                "value": data.nepal.technology,
                "rank": data.nepal.technology_rank,
            },
            "HumanCapital": {
                "value": data.nepal.human_capital,
                "rank": data.nepal.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.nepal.competitiveness,
                "rank": data.nepal.competitiveness_rank,
            }
        },
        {
            "Country": "Netherlands",
            "FREI": {
                "value": data.netherlands.future_readiness_score,
                "rank": data.netherlands.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.netherlands.physical_capital,
                "rank": data.netherlands.physical_capital_rank,
            },
            "Technology": {
                "value": data.netherlands.technology,
                "rank": data.netherlands.technology_rank,
            },
            "HumanCapital": {
                "value": data.netherlands.human_capital,
                "rank": data.netherlands.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.netherlands.competitiveness,
                "rank": data.netherlands.competitiveness_rank,
            }
        },
        {
            "Country": "New Zealand",
            "FREI": {
                "value": data.new_zealand.future_readiness_score,
                "rank": data.new_zealand.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.new_zealand.physical_capital,
                "rank": data.new_zealand.physical_capital_rank,
            },
            "Technology": {
                "value": data.new_zealand.technology,
                "rank": data.new_zealand.technology_rank,
            },
            "HumanCapital": {
                "value": data.new_zealand.human_capital,
                "rank": data.new_zealand.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.new_zealand.competitiveness,
                "rank": data.new_zealand.competitiveness_rank,
            }
        },
        {
            "Country": "Niger",
            "FREI": {
                "value": data.niger.future_readiness_score,
                "rank": data.niger.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.niger.physical_capital,
                "rank": data.niger.physical_capital_rank,
            },
            "Technology": {
                "value": data.niger.technology,
                "rank": data.niger.technology_rank,
            },
            "HumanCapital": {
                "value": data.niger.human_capital,
                "rank": data.niger.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.niger.competitiveness,
                "rank": data.niger.competitiveness_rank,
            }
        },
        {
            "Country": "Nigeria",
            "FREI": {
                "value": data.nigeria.future_readiness_score,
                "rank": data.nigeria.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.nigeria.physical_capital,
                "rank": data.nigeria.physical_capital_rank,
            },
            "Technology": {
                "value": data.nigeria.technology,
                "rank": data.nigeria.technology_rank,
            },
            "HumanCapital": {
                "value": data.nigeria.human_capital,
                "rank": data.nigeria.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.nigeria.competitiveness,
                "rank": data.nigeria.competitiveness_rank,
            }
        },
        {
            "Country": "North Macedonia",
            "FREI": {
                "value": data.north_macedonia.future_readiness_score,
                "rank": data.north_macedonia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.north_macedonia.physical_capital,
                "rank": data.north_macedonia.physical_capital_rank,
            },
            "Technology": {
                "value": data.north_macedonia.technology,
                "rank": data.north_macedonia.technology_rank,
            },
            "HumanCapital": {
                "value": data.north_macedonia.human_capital,
                "rank": data.north_macedonia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.north_macedonia.competitiveness,
                "rank": data.north_macedonia.competitiveness_rank,
            }
        },
        {
            "Country": "Norway",
            "FREI": {
                "value": data.norway.future_readiness_score,
                "rank": data.norway.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.norway.physical_capital,
                "rank": data.norway.physical_capital_rank,
            },
            "Technology": {
                "value": data.norway.technology,
                "rank": data.norway.technology_rank,
            },
            "HumanCapital": {
                "value": data.norway.human_capital,
                "rank": data.norway.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.norway.competitiveness,
                "rank": data.norway.competitiveness_rank,
            }
        },
        {
            "Country": "Oman",
            "FREI": {
                "value": data.oman.future_readiness_score,
                "rank": data.oman.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.oman.physical_capital,
                "rank": data.oman.physical_capital_rank,
            },
            "Technology": {
                "value": data.oman.technology,
                "rank": data.oman.technology_rank,
            },
            "HumanCapital": {
                "value": data.oman.human_capital,
                "rank": data.oman.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.oman.competitiveness,
                "rank": data.oman.competitiveness_rank,
            }
        },
        {
            "Country": "Pakistan",
            "FREI": {
                "value": data.pakistan.future_readiness_score,
                "rank": data.pakistan.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.pakistan.physical_capital,
                "rank": data.pakistan.physical_capital_rank,
            },
            "Technology": {
                "value": data.pakistan.technology,
                "rank": data.pakistan.technology_rank,
            },
            "HumanCapital": {
                "value": data.pakistan.human_capital,
                "rank": data.pakistan.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.pakistan.competitiveness,
                "rank": data.pakistan.competitiveness_rank,
            }
        },
        {
            "Country": "Panama",
            "FREI": {
                "value": data.panama.future_readiness_score,
                "rank": data.panama.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.panama.physical_capital,
                "rank": data.panama.physical_capital_rank,
            },
            "Technology": {
                "value": data.panama.technology,
                "rank": data.panama.technology_rank,
            },
            "HumanCapital": {
                "value": data.panama.human_capital,
                "rank": data.panama.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.panama.competitiveness,
                "rank": data.panama.competitiveness_rank,
            }
        },
        {
            "Country": "Paraguay",
            "FREI": {
                "value": data.paraguay.future_readiness_score,
                "rank": data.paraguay.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.paraguay.physical_capital,
                "rank": data.paraguay.physical_capital_rank,
            },
            "Technology": {
                "value": data.paraguay.technology,
                "rank": data.paraguay.technology_rank,
            },
            "HumanCapital": {
                "value": data.paraguay.human_capital,
                "rank": data.paraguay.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.paraguay.competitiveness,
                "rank": data.paraguay.competitiveness_rank,
            }
        },
        {
            "Country": "Peru",
            "FREI": {
                "value": data.peru.future_readiness_score,
                "rank": data.peru.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.peru.physical_capital,
                "rank": data.peru.physical_capital_rank,
            },
            "Technology": {
                "value": data.peru.technology,
                "rank": data.peru.technology_rank,
            },
            "HumanCapital": {
                "value": data.peru.human_capital,
                "rank": data.peru.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.peru.competitiveness,
                "rank": data.peru.competitiveness_rank,
            }
        },
        {
            "Country": "Philippines",
            "FREI": {
                "value": data.philippines.future_readiness_score,
                "rank": data.philippines.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.philippines.physical_capital,
                "rank": data.philippines.physical_capital_rank,
            },
            "Technology": {
                "value": data.philippines.technology,
                "rank": data.philippines.technology_rank,
            },
            "HumanCapital": {
                "value": data.philippines.human_capital,
                "rank": data.philippines.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.philippines.competitiveness,
                "rank": data.philippines.competitiveness_rank,
            }
        },
        {
            "Country": "Poland",
            "FREI": {
                "value": data.poland.future_readiness_score,
                "rank": data.poland.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.poland.physical_capital,
                "rank": data.poland.physical_capital_rank,
            },
            "Technology": {
                "value": data.poland.technology,
                "rank": data.poland.technology_rank,
            },
            "HumanCapital": {
                "value": data.poland.human_capital,
                "rank": data.poland.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.poland.competitiveness,
                "rank": data.poland.competitiveness_rank,
            }
        },
        {
            "Country": "Portugal",
            "FREI": {
                "value": data.portugal.future_readiness_score,
                "rank": data.portugal.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.portugal.physical_capital,
                "rank": data.portugal.physical_capital_rank,
            },
            "Technology": {
                "value": data.portugal.technology,
                "rank": data.portugal.technology_rank,
            },
            "HumanCapital": {
                "value": data.portugal.human_capital,
                "rank": data.portugal.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.portugal.competitiveness,
                "rank": data.portugal.competitiveness_rank,
            }
        },
        {
            "Country": "Qatar",
            "FREI": {
                "value": data.qatar.future_readiness_score,
                "rank": data.qatar.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.qatar.physical_capital,
                "rank": data.qatar.physical_capital_rank,
            },
            "Technology": {
                "value": data.qatar.technology,
                "rank": data.qatar.technology_rank,
            },
            "HumanCapital": {
                "value": data.qatar.human_capital,
                "rank": data.qatar.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.qatar.competitiveness,
                "rank": data.qatar.competitiveness_rank,
            }
        },
        {
            "Country": "Romania",
            "FREI": {
                "value": data.romania.future_readiness_score,
                "rank": data.romania.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.romania.physical_capital,
                "rank": data.romania.physical_capital_rank,
            },
            "Technology": {
                "value": data.romania.technology,
                "rank": data.romania.technology_rank,
            },
            "HumanCapital": {
                "value": data.romania.human_capital,
                "rank": data.romania.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.romania.competitiveness,
                "rank": data.romania.competitiveness_rank,
            }
        },
        {
            "Country": "Russia",
            "FREI": {
                "value": data.russia.future_readiness_score,
                "rank": data.russia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.russia.physical_capital,
                "rank": data.russia.physical_capital_rank,
            },
            "Technology": {
                "value": data.russia.technology,
                "rank": data.russia.technology_rank,
            },
            "HumanCapital": {
                "value": data.russia.human_capital,
                "rank": data.russia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.russia.competitiveness,
                "rank": data.russia.competitiveness_rank,
            }
        },
        {
            "Country": "Rwanda",
            "FREI": {
                "value": data.rwanda.future_readiness_score,
                "rank": data.rwanda.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.rwanda.physical_capital,
                "rank": data.rwanda.physical_capital_rank,
            },
            "Technology": {
                "value": data.rwanda.technology,
                "rank": data.rwanda.technology_rank,
            },
            "HumanCapital": {
                "value": data.rwanda.human_capital,
                "rank": data.rwanda.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.rwanda.competitiveness,
                "rank": data.rwanda.competitiveness_rank,
            }
        },
        {
            "Country": "Saudi Arabia",
            "FREI": {
                "value": data.saudi_arabia.future_readiness_score,
                "rank": data.saudi_arabia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.saudi_arabia.physical_capital,
                "rank": data.saudi_arabia.physical_capital_rank,
            },
            "Technology": {
                "value": data.saudi_arabia.technology,
                "rank": data.saudi_arabia.technology_rank,
            },
            "HumanCapital": {
                "value": data.saudi_arabia.human_capital,
                "rank": data.saudi_arabia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.saudi_arabia.competitiveness,
                "rank": data.saudi_arabia.competitiveness_rank,
            }
        },
        {
            "Country": "Senegal",
            "FREI": {
                "value": data.senegal.future_readiness_score,
                "rank": data.senegal.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.senegal.physical_capital,
                "rank": data.senegal.physical_capital_rank,
            },
            "Technology": {
                "value": data.senegal.technology,
                "rank": data.senegal.technology_rank,
            },
            "HumanCapital": {
                "value": data.senegal.human_capital,
                "rank": data.senegal.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.senegal.competitiveness,
                "rank": data.senegal.competitiveness_rank,
            }
        },
        {
            "Country": "Serbia",
            "FREI": {
                "value": data.serbia.future_readiness_score,
                "rank": data.serbia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.serbia.physical_capital,
                "rank": data.serbia.physical_capital_rank,
            },
            "Technology": {
                "value": data.serbia.technology,
                "rank": data.serbia.technology_rank,
            },
            "HumanCapital": {
                "value": data.serbia.human_capital,
                "rank": data.serbia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.serbia.competitiveness,
                "rank": data.serbia.competitiveness_rank,
            }
        },
        {
            "Country": "Singapore",
            "FREI": {
                "value": data.singapore.future_readiness_score,
                "rank": data.singapore.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.singapore.physical_capital,
                "rank": data.singapore.physical_capital_rank,
            },
            "Technology": {
                "value": data.singapore.technology,
                "rank": data.singapore.technology_rank,
            },
            "HumanCapital": {
                "value": data.singapore.human_capital,
                "rank": data.singapore.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.singapore.competitiveness,
                "rank": data.singapore.competitiveness_rank,
            }
        },
        {
            "Country": "Slovakia",
            "FREI": {
                "value": data.slovakia.future_readiness_score,
                "rank": data.slovakia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.slovakia.physical_capital,
                "rank": data.slovakia.physical_capital_rank,
            },
            "Technology": {
                "value": data.slovakia.technology,
                "rank": data.slovakia.technology_rank,
            },
            "HumanCapital": {
                "value": data.slovakia.human_capital,
                "rank": data.slovakia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.slovakia.competitiveness,
                "rank": data.slovakia.competitiveness_rank,
            }
        },
        {
            "Country": "Slovenia",
            "FREI": {
                "value": data.slovenia.future_readiness_score,
                "rank": data.slovenia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.slovenia.physical_capital,
                "rank": data.slovenia.physical_capital_rank,
            },
            "Technology": {
                "value": data.slovenia.technology,
                "rank": data.slovenia.technology_rank,
            },
            "HumanCapital": {
                "value": data.slovenia.human_capital,
                "rank": data.slovenia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.slovenia.competitiveness,
                "rank": data.slovenia.competitiveness_rank,
            }
        },
        {
            "Country": "South Africa",
            "FREI": {
                "value": data.south_africa.future_readiness_score,
                "rank": data.south_africa.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.south_africa.physical_capital,
                "rank": data.south_africa.physical_capital_rank,
            },
            "Technology": {
                "value": data.south_africa.technology,
                "rank": data.south_africa.technology_rank,
            },
            "HumanCapital": {
                "value": data.south_africa.human_capital,
                "rank": data.south_africa.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.south_africa.competitiveness,
                "rank": data.south_africa.competitiveness_rank,
            }
        },
        {
            "Country": "South Korea",
            "FREI": {
                "value": data.south_korea.future_readiness_score,
                "rank": data.south_korea.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.south_korea.physical_capital,
                "rank": data.south_korea.physical_capital_rank,
            },
            "Technology": {
                "value": data.south_korea.technology,
                "rank": data.south_korea.technology_rank,
            },
            "HumanCapital": {
                "value": data.south_korea.human_capital,
                "rank": data.south_korea.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.south_korea.competitiveness,
                "rank": data.south_korea.competitiveness_rank,
            }
        },
        {
            "Country": "Spain",
            "FREI": {
                "value": data.spain.future_readiness_score,
                "rank": data.spain.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.spain.physical_capital,
                "rank": data.spain.physical_capital_rank,
            },
            "Technology": {
                "value": data.spain.technology,
                "rank": data.spain.technology_rank,
            },
            "HumanCapital": {
                "value": data.spain.human_capital,
                "rank": data.spain.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.spain.competitiveness,
                "rank": data.spain.competitiveness_rank,
            }
        },
        {
            "Country": "Sri Lanka",
            "FREI": {
                "value": data.sri_lanka.future_readiness_score,
                "rank": data.sri_lanka.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.sri_lanka.physical_capital,
                "rank": data.sri_lanka.physical_capital_rank,
            },
            "Technology": {
                "value": data.sri_lanka.technology,
                "rank": data.sri_lanka.technology_rank,
            },
            "HumanCapital": {
                "value": data.sri_lanka.human_capital,
                "rank": data.sri_lanka.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.sri_lanka.competitiveness,
                "rank": data.sri_lanka.competitiveness_rank,
            }
        },
        {
            "Country": "Sweden",
            "FREI": {
                "value": data.sweden.future_readiness_score,
                "rank": data.sweden.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.sweden.physical_capital,
                "rank": data.sweden.physical_capital_rank,
            },
            "Technology": {
                "value": data.sweden.technology,
                "rank": data.sweden.technology_rank,
            },
            "HumanCapital": {
                "value": data.sweden.human_capital,
                "rank": data.sweden.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.sweden.competitiveness,
                "rank": data.sweden.competitiveness_rank,
            }
        },
        {
            "Country": "Switzerland",
            "FREI": {
                "value": data.switzerland.future_readiness_score,
                "rank": data.switzerland.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.switzerland.physical_capital,
                "rank": data.switzerland.physical_capital_rank,
            },
            "Technology": {
                "value": data.switzerland.technology,
                "rank": data.switzerland.technology_rank,
            },
            "HumanCapital": {
                "value": data.switzerland.human_capital,
                "rank": data.switzerland.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.switzerland.competitiveness,
                "rank": data.switzerland.competitiveness_rank,
            }
        },
        {
            "Country": "Tanzania",
            "FREI": {
                "value": data.tanzania.future_readiness_score,
                "rank": data.tanzania.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.tanzania.physical_capital,
                "rank": data.tanzania.physical_capital_rank,
            },
            "Technology": {
                "value": data.tanzania.technology,
                "rank": data.tanzania.technology_rank,
            },
            "HumanCapital": {
                "value": data.tanzania.human_capital,
                "rank": data.tanzania.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.tanzania.competitiveness,
                "rank": data.tanzania.competitiveness_rank,
            }
        },
        {
            "Country": "Thailand",
            "FREI": {
                "value": data.thailand.future_readiness_score,
                "rank": data.thailand.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.thailand.physical_capital,
                "rank": data.thailand.physical_capital_rank,
            },
            "Technology": {
                "value": data.thailand.technology,
                "rank": data.thailand.technology_rank,
            },
            "HumanCapital": {
                "value": data.thailand.human_capital,
                "rank": data.thailand.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.thailand.competitiveness,
                "rank": data.thailand.competitiveness_rank,
            }
        },
        {
            "Country": "Togo",
            "FREI": {
                "value": data.togo.future_readiness_score,
                "rank": data.togo.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.togo.physical_capital,
                "rank": data.togo.physical_capital_rank,
            },
            "Technology": {
                "value": data.togo.technology,
                "rank": data.togo.technology_rank,
            },
            "HumanCapital": {
                "value": data.togo.human_capital,
                "rank": data.togo.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.togo.competitiveness,
                "rank": data.togo.competitiveness_rank,
            }
        },
        {
            "Country": "Trinidad and Tobago",
            "FREI": {
                "value": data.trinidad_and_tobago.future_readiness_score,
                "rank": data.trinidad_and_tobago.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.trinidad_and_tobago.physical_capital,
                "rank": data.trinidad_and_tobago.physical_capital_rank,
            },
            "Technology": {
                "value": data.trinidad_and_tobago.technology,
                "rank": data.trinidad_and_tobago.technology_rank,
            },
            "HumanCapital": {
                "value": data.trinidad_and_tobago.human_capital,
                "rank": data.trinidad_and_tobago.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.trinidad_and_tobago.competitiveness,
                "rank": data.trinidad_and_tobago.competitiveness_rank,
            }
        },
        {
            "Country": "Tunisia",
            "FREI": {
                "value": data.tunisia.future_readiness_score,
                "rank": data.tunisia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.tunisia.physical_capital,
                "rank": data.tunisia.physical_capital_rank,
            },
            "Technology": {
                "value": data.tunisia.technology,
                "rank": data.tunisia.technology_rank,
            },
            "HumanCapital": {
                "value": data.tunisia.human_capital,
                "rank": data.tunisia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.tunisia.competitiveness,
                "rank": data.tunisia.competitiveness_rank,
            }
        },
        {
            "Country": "Türkiye",
            "FREI": {
                "value": data.turkey.future_readiness_score,
                "rank": data.turkey.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.turkey.physical_capital,
                "rank": data.turkey.physical_capital_rank,
            },
            "Technology": {
                "value": data.turkey.technology,
                "rank": data.turkey.technology_rank,
            },
            "HumanCapital": {
                "value": data.turkey.human_capital,
                "rank": data.turkey.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.turkey.competitiveness,
                "rank": data.turkey.competitiveness_rank,
            }
        },
        {
            "Country": "Uganda",
            "FREI": {
                "value": data.uganda.future_readiness_score,
                "rank": data.uganda.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.uganda.physical_capital,
                "rank": data.uganda.physical_capital_rank,
            },
            "Technology": {
                "value": data.uganda.technology,
                "rank": data.uganda.technology_rank,
            },
            "HumanCapital": {
                "value": data.uganda.human_capital,
                "rank": data.uganda.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.uganda.competitiveness,
                "rank": data.uganda.competitiveness_rank,
            }
        },
        {
            "Country": "Ukraine",
            "FREI": {
                "value": data.ukraine.future_readiness_score,
                "rank": data.ukraine.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.ukraine.physical_capital,
                "rank": data.ukraine.physical_capital_rank,
            },
            "Technology": {
                "value": data.ukraine.technology,
                "rank": data.ukraine.technology_rank,
            },
            "HumanCapital": {
                "value": data.ukraine.human_capital,
                "rank": data.ukraine.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.ukraine.competitiveness,
                "rank": data.ukraine.competitiveness_rank,
            }
        },
        {
            "Country": "United Arab Emirates",
            "FREI": {
                "value": data.united_arab_emirates.future_readiness_score,
                "rank": data.united_arab_emirates.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.united_arab_emirates.physical_capital,
                "rank": data.united_arab_emirates.physical_capital_rank,
            },
            "Technology": {
                "value": data.united_arab_emirates.technology,
                "rank": data.united_arab_emirates.technology_rank,
            },
            "HumanCapital": {
                "value": data.united_arab_emirates.human_capital,
                "rank": data.united_arab_emirates.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.united_arab_emirates.competitiveness,
                "rank": data.united_arab_emirates.competitiveness_rank,
            }
        },
        {
            "Country": "United Kingdom",
            "FREI": {
                "value": data.united_kingdom.future_readiness_score,
                "rank": data.united_kingdom.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.united_kingdom.physical_capital,
                "rank": data.united_kingdom.physical_capital_rank,
            },
            "Technology": {
                "value": data.united_kingdom.technology,
                "rank": data.united_kingdom.technology_rank,
            },
            "HumanCapital": {
                "value": data.united_kingdom.human_capital,
                "rank": data.united_kingdom.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.united_kingdom.competitiveness,
                "rank": data.united_kingdom.competitiveness_rank,
            }
        },
        {
            "Country": "United States",
            "FREI": {
                "value": data.united_states.future_readiness_score,
                "rank": data.united_states.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.united_states.physical_capital,
                "rank": data.united_states.physical_capital_rank,
            },
            "Technology": {
                "value": data.united_states.technology,
                "rank": data.united_states.technology_rank,
            },
            "HumanCapital": {
                "value": data.united_states.human_capital,
                "rank": data.united_states.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.united_states.competitiveness,
                "rank": data.united_states.competitiveness_rank,
            }
        },
        {
            "Country": "Uruguay",
            "FREI": {
                "value": data.uruguay.future_readiness_score,
                "rank": data.uruguay.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.uruguay.physical_capital,
                "rank": data.uruguay.physical_capital_rank,
            },
            "Technology": {
                "value": data.uruguay.technology,
                "rank": data.uruguay.technology_rank,
            },
            "HumanCapital": {
                "value": data.uruguay.human_capital,
                "rank": data.uruguay.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.uruguay.competitiveness,
                "rank": data.uruguay.competitiveness_rank,
            }
        },
        {
            "Country": "Vietnam",
            "FREI": {
                "value": data.vietnam.future_readiness_score,
                "rank": data.vietnam.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.vietnam.physical_capital,
                "rank": data.vietnam.physical_capital_rank,
            },
            "Technology": {
                "value": data.vietnam.technology,
                "rank": data.vietnam.technology_rank,
            },
            "HumanCapital": {
                "value": data.vietnam.human_capital,
                "rank": data.vietnam.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.vietnam.competitiveness,
                "rank": data.vietnam.competitiveness_rank,
            }
        },
        {
            "Country": "Zambia",
            "FREI": {
                "value": data.zambia.future_readiness_score,
                "rank": data.zambia.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.zambia.physical_capital,
                "rank": data.zambia.physical_capital_rank,
            },
            "Technology": {
                "value": data.zambia.technology,
                "rank": data.zambia.technology_rank,
            },
            "HumanCapital": {
                "value": data.zambia.human_capital,
                "rank": data.zambia.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.zambia.competitiveness,
                "rank": data.zambia.competitiveness_rank,
            }
        },
        {
            "Country": "Zimbabwe",
            "FREI": {
                "value": data.zimbabwe.future_readiness_score,
                "rank": data.zimbabwe.future_readiness_rank,
            },
            "PhysicalCapital": {
                "value": data.zimbabwe.physical_capital,
                "rank": data.zimbabwe.physical_capital_rank,
            },
            "Technology": {
                "value": data.zimbabwe.technology,
                "rank": data.zimbabwe.technology_rank,
            },
            "HumanCapital": {
                "value": data.zimbabwe.human_capital,
                "rank": data.zimbabwe.human_capital_rank,
            },
            "Competitiveness": {
                "value": data.zimbabwe.competitiveness,
                "rank": data.zimbabwe.competitiveness_rank,
            }
        }
    ]
}

export default countryWhatIfsData
